<template>
  <div class="table-header">
    <div class="table-item">
      <div>ID</div>
    </div>
    <div class="table-item photos-item">
      <div>{{ changePatientClient ? 'Пациент | клиент' : 'Пациент' }}</div>
    </div>
    <div class="table-item">
      <div>Сроки</div>
    </div>
    <div class="table-item">
      <div>Изделия</div>
    </div>
    <div v-if="additional === 'Исполнитель'" class="table-item">{{ additional }} </div>
    <div v-if="!hidePrice" class="table-item">
      <div>Сумма</div>
    </div>
    <div v-if="additional && additional !== '' &&  additional !== 'Исполнитель'" class="table-item">{{ additional }} </div>
    <div v-if="additional2" class="table-item" />
    <div class="table-item table-chevron"></div>
  </div>
</template>

<script>
  export default {
    name: 'TableHeader',
    props: {
      additional: {
        type: String,
        default: '',
      },
      additional2: Boolean,
      hidePrice: Boolean,
      changePatientClient: Boolean,
    },
  };
</script>
